import { render, staticRenderFns } from "./loan-calculator.vue?vue&type=template&id=ca4a7a3a&scoped=true&"
import script from "./loan-calculator.vue?vue&type=script&lang=js&"
export * from "./loan-calculator.vue?vue&type=script&lang=js&"
import style0 from "./loan-calculator.vue?vue&type=style&index=0&id=ca4a7a3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4a7a3a",
  null
  
)

export default component.exports